<i
    class="shrink-0 text-[27px]"
    [ngClass]="[icon() ?? 'animated-arrow-right', inverted() ? 'text-white' : 'text-accent']"
></i>
<span
    class="flex-1 text-left font-headline text-16 leading-20 group-hover:underline"
    [ngClass]="[inverted() ? 'text-white' : 'text-accent']"
>
    <ng-content />
</span>
